'use client';
import styled from 'styled-components';
import { colors } from '@/styles';

export const WaveSurferPlayer = styled.div`
  background: ${colors.secondary.lightGray1};
  border: 1px solid ${colors.secondary.lightGray2};
  border-radius: 5px;
`;

export const PlayerWindow = styled.div`
  position: relative;
  min-height: 130px;
  padding: 5px;
`;

export const AudioControl = styled.div`
  display: flex;
  /* margin-top: 20px; */
  align-items: center;
  justify-content: space-between;
  background: ${colors.secondary.lightGray2};
  border-top: 1px solid ${colors.secondary.lightGray2};
  /* border: 1px solid ${colors.secondary.lightGray2}; */
  padding: 10px;
`;

export const PausePlayButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 5px;
  background: ${colors.secondary.lightGray3};
`;

export const DurationIndicator = styled.div`
  font-family: var(--font-family-mono);
  margin-right: 10px;
`;
